module.exports = __webpack_public_path__ + "static/OP5-9065669b122399a08934b704cd3ff2ee.jpg";